import moment from 'moment'
import { Expose, Transform, Type } from 'class-transformer'
import { Inbox } from 'react-feather'

import { Base } from './Base'
import { Place } from './Place'

export class ContainerASN {
  @Expose({ name: 'xid' })
  guid?: string

  @Expose({ name: 'tracking_number' })
  trackingNumber?: string

  @Expose({ name: 'bill_of_lading_number' })
  billOfLadingNumber?: string

  @Expose({ name: 'custom_fields' })
  customFields?: Record<string, string>
}

export class Container extends Base {
  static type = 'container'
  static typeDisplay = 'Container'
  static icon = Inbox

  type = Container.type
  typeDisplay = Container.typeDisplay
  icon = Container.icon

  @Expose({ name: 'xid' })
  guid: string = ''

  name: string = ''

  @Expose({ name: 'retired_on' })
  @Transform((value) => (value ? moment(value) : value))
  retiredOn?: moment.Moment

  @Expose({ name: 'retired_from' })
  @Type(() => Place)
  retiredFrom?: moment.Moment

  @Expose({ name: 'is_lost' })
  isLost?: boolean

  @Expose({ name: 'can_delete' })
  canDelete?: boolean

  @Expose({ name: 'can_retire' })
  canRetire?: boolean

  @Type(() => Place)
  place?: Place

  @Type(() => ContainerASN)
  asn?: ContainerASN

  @Expose({ name: 'total_units' })
  totalUnits: number = 0

  get facility() {
    if (this.place) {
      return this.place.facility
    }
    return null
  }

  @Expose({ name: 'container_type' })
  containerType?: string

  @Expose({ name: 'for_shipping' })
  forShipping?: boolean

  @Expose({ name: 'internal_notes' })
  internalNotes?: string

  @Expose({ name: 'review_needed' })
  reviewNeeded?: boolean

  @Expose({ name: 'review_reason' })
  reviewReason?: string

  get path() {
    const items = []
    if (this.place) {
      items.push(this.place.path)
    }
    items.push(this.name)
    return items.join(' > ')
  }

  get objPath() {
    const items = []
    if (this.place) {
      items.push(...this.place.objPath)
    }
    items.push(this)
    return items
  }
}
